import qs from "qs";

import ZoneApi from "../../services/api/Zone";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import { getPath } from "../../utils";

function handleError(err) {
  console.log("error in zone actions:", err);
}

export const setZonesList = (payload) => {
  return {
    type: ActionTypes.SET_ZONE_LIST,
    payload,
  };
};

export const setCurrentPageZone = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_ZONE,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_ZONE_FILTERS,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_ZONE,
    payload,
  };
};

export const setActiveZone = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_ZONE,
    payload,
  };
};

export const getZoneList =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...pageRequest,
        zone_supported: true,
      };
      if (getPath(filters, "startswith.length", -1) > 0) {
        finalPayload["startswith"] = filters.startswith;
        delete filters.startswith;
      } else if (
        filters.hasOwnProperty("startswith") &&
        filters["startswith"] === ""
      ) {
        delete filters.startswith;
      }
      if (Object.keys(filters).length > 0) {
        Object.keys(filters).map((key) => {
          finalPayload[key] = filters[key];
        });
      }
      // change city_id to array
      if (
        getPath(finalPayload, "city_id", undefined) &&
        !Array.isArray(finalPayload["city_id"])
      ) {
        finalPayload["city_id"] = [finalPayload["city_id"]];
      }

      const queryString = qs.stringify(finalPayload);
      dispatch(setLoader(true));
      let response = await ZoneApi.getZoneList(queryString);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setZonesList(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(setCurrentPageZone(getPath(pageRequest, "page", 1)));
        }
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
        return response;
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getZone = (id) => async (dispatch) => {
  try {
    let finalPayload = {
      id: id,
    };
    dispatch(setLoader(true));
    let response = await ZoneApi.getZone(finalPayload);
    dispatch(setLoader(false));
    if (response) {
      const zoneObj = getPath(response, "zone", {});
      dispatch(setActiveZone(zoneObj));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getBulkZones = (zoneIds) => async (dispatch) => {
  try {
    var zones = [];
    dispatch(setLoader(true));
    for (const id of zoneIds) {
      let finalPayload = {
        id: id,
      };
      let response = await ZoneApi.getZone(finalPayload);
      if (response) {
        zones = [...zones, getPath(response, "zone", {})];
      }
    }
    dispatch(setLoader(false));
    return zones;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
